/**
 * Day Archive Page (/day/:n)
 * The page that owns "WriteFlow #6" — the searchable name of a day used in
 * share artifacts. Shows that day's prompt and everything written for it.
 */

import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import SinglePostDisplay from '../components/post/SinglePostDisplay';
import PromptContextCard from '../components/post/PromptContextCard';
import { formatPromptDate } from '../utils/formatPromptDate';

const DayArchivePage = () => {
  const { n } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  const fetchDay = useCallback(async () => {
    setLoading(true);
    setNotFound(false);
    try {
      const res = await axios.get(`/api/prompts/day/${encodeURIComponent(n)}`);
      setData(res.data);
    } catch (error) {
      setNotFound(true);
    } finally {
      setLoading(false);
    }
  }, [n]);

  useEffect(() => {
    fetchDay();
  }, [fetchDay]);

  if (loading) {
    return <div className="container"><div className="loading">Loading...</div></div>;
  }

  if (notFound || !data?.prompt) {
    return (
      <div className="container">
        <h1>WriteFlow #{n}</h1>
        <div className="no-posts">
          <p>No prompt for this day.</p>
          <Link to="/">Write today's prompt instead →</Link>
        </div>
      </div>
    );
  }

  const { prompt, posts, dayNumber } = data;

  return (
    <div className="container">
      <h1>WriteFlow #{dayNumber}</h1>
      {prompt.date && <p className="day-archive-date">{formatPromptDate(prompt.date)}</p>}
      <PromptContextCard prompt={prompt} badge={`Prompt #${dayNumber}`} linkToDay={false} />
      {posts.length === 0 ? (
        <div className="no-posts">
          <p>No one wrote for this prompt.</p>
          <Link to="/">Write today's prompt →</Link>
        </div>
      ) : (
        <div className="posts-list">
          {posts.map((post) => (
            <SinglePostDisplay key={post._id} post={post} onUpdate={fetchDay} />
          ))}
        </div>
      )}
    </div>
  );
};

export default DayArchivePage;
